var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.companyFullName) ? _c('v-menu', {
    attrs: {
      "right": "",
      "options": _vm.options
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('v-link', {
    attrs: {
      "size": "subheadling"
    }
  }, [_vm._v(_vm._s(_vm.companyFullName))]), _vm._v(" "), _c('v-text', {
    directives: [{
      name: "margin",
      rawName: "v-margin.xs.left",
      value: (1),
      expression: "1",
      modifiers: {
        "xs": true,
        "left": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.right",
      value: (1),
      expression: "1",
      modifiers: {
        "right": true
      }
    }],
    attrs: {
      "type": "caption"
    }
  }, [_vm._v("\n            ID: " + _vm._s(_vm.companyId) + "\n        ")]), _vm._v(" "), _c('v-font-icon', [_vm._v("\n            arrow_drop_down\n        ")])], 1) : _c('v-spinner')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a3ecc6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/AppBar/CompanyMenu.vue
// module id = 1174
// module chunks = 0